import { vars } from "@pancakeswap/ui/css/vars.css";
import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Logo: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return <img {...props} src="/images/logo/logo-with-text.webp" width={150} alt="Logo With Text" />;
};

export default Logo;
